// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"SupplierCommMasterPage_inputContainer__HAe-l","headerActions":"SupplierCommMasterPage_headerActions__3MLR7"};